import { CloseOutlined, DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Checkbox, ConfigProvider, DatePicker, Pagination, Radio, RadioChangeEvent, Select, Switch, Tabs, TabsProps, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { backRemovedPost, changePostPage, feedFilterClear, feedFilterSubmit, fetchPosts, fetchStopPost, removeRefPost } from "../redux/actions";
import FeedStatistics from "./feed-statistics/feed-statistics";
import IconChecked from "./icons/checked";
import IconUndo from "./icons/undo";
import Post from "./post";
import locale from "antd/es/date-picker/locale/ru_RU";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { getPostCount, getPostIsLoading, getPostList, getPostPageNumber, getPostPageSize, getReferences, getReferencesFilter, getThread } from "../redux/selectors";
import { useAppDispatch } from "../redux/store/hooks";

const PostsThread: React.FC = () => {
    const [value, setValue] = useState("today");
    const { RangePicker } = DatePicker;
    const feedFilter = useSelector(getFeedFilter);
    const [tonality, setTonality] = useState(feedFilter.tonal);
    const [tonal, setTonal] = useState();
    const [repostOption, setRepostOption] = useState(feedFilter.repostoption);
    const [friendly, setFriendly] = useState(feedFilter.friendly);
    const [sorting, setSorting] = useState(feedFilter.sort);
    const [switchValue, setSwitchValue] = useState(false);
    const [checkedPosts, setCheckedPosts] = useState([]);
    const current = window.location.pathname.split("/")[2];
    const [tab, setTab] = useState("post");
    const referencesFilter = useSelector(getReferencesFilter);
    const references = useSelector(getReferences);
    const [dateString, setDateString] = useState([
      feedFilter.from,
      feedFilter.to,
    ]);
    const isLoading = useSelector(getPostIsLoading);
    const postList = useSelector(getPostList);
    const postCount = useSelector(getPostCount);
    const pageNumber = useSelector(getPostPageNumber);
    const pageSize = useSelector(getPostPageSize);
    const options = [
      { label: " Другое", value: "period" },
      { label: "Сегодня", value: "today" },
      { label: "7д", value: "week" },
      { label: "1м", value: "month" },
    ];
  
    const thread = useSelector(getThread);

  
    let netOptions: any = [];
    if (thread?.networks?.includes(1))
      netOptions.push({ value: "vk", label: "ВКонтакте" });
    if (thread?.networks?.includes(2))
      netOptions.push({ value: "tw", label: "Twitter" });
    if (thread?.networks?.includes(3))
      netOptions.push({ value: "fb", label: "Facebook" });
    if (thread?.networks?.includes(5))
      netOptions.push({ value: "tg", label: "Telegram" });
    if (thread?.networks?.includes(7))
      netOptions.push({ value: "ig", label: "Instagram" });
    if (thread?.networks?.includes(8))
      netOptions.push({ value: "yt", label: "Youtube" });
    if (thread?.networks?.includes(10))
      netOptions.push({ value: "ok", label: "Одноклассники" });
    if (thread?.networks?.includes(11))
      netOptions.push({ value: "dz", label: "Дзен" });
    if (thread?.networks?.includes(4))
      netOptions.push({ value: "smi", label: "СМИ" });
  
    const [source, setSource] = useState({
      smi: feedFilter.smi,
      vk: feedFilter.vk,
      tw: feedFilter.tw,
      ig: feedFilter.ig,
      tg: feedFilter.tg,
      yt: feedFilter.yt,
      dz: feedFilter.dz,
      ok: feedFilter.ok,
      fb: feedFilter.fb,
    });
    const [sourceChange, setSourceChange] = useState({
      smi: feedFilter.smi,
      vk: feedFilter.vk,
      tw: feedFilter.tw,
      ig: feedFilter.ig,
      tg: feedFilter.tg,
      yt: feedFilter.yt,
      dz: feedFilter.dz,
      ok: feedFilter.ok,
      fb: feedFilter.fb,
    });
    const [sourceOptions, setSourceOptions] = useState([
      "tg",
      "vk",
      "ok",
      "fb",
      "tw",
      "yt",
      "dz",
      "ig",
      "smi",
    ]);
  
    const dispatch = useAppDispatch();
  
    useEffect(() => {
      onClear();
    }, []);
  
    useEffect(() => {
      dispatch(
        feedFilterSubmit({
          from: dateString[0].slice(0, 10) + " 00:00:00",
          to: dateString[1].slice(0, 10) + " 23:59:59",
          smi: thread?.networks?.includes(4) && source.smi,
          vk: thread?.networks?.includes(1) && source.vk,
          tw: thread?.networks?.includes(2) && source.tw,
          fb: thread?.networks?.includes(3) && source.fb,
          ig: thread?.networks?.includes(7) && source.ig,
          tg: thread?.networks?.includes(5) && source.tg,
          yt: thread?.networks?.includes(8) && source.yt,
          dz: thread?.networks?.includes(11) && source.dz,
          ok: thread?.networks?.includes(10) && source.ok,
          tonal: tonality,
          friendly: friendly,
          sorting: sorting,
          profile_id: [],
          repostoption: repostOption,
        })
      );
      if (thread && tab == "post") dispatch(fetchPosts());
      if (thread && tab == "stop") dispatch(fetchStopPost());
    }, [source, dateString, sorting, tonality, thread, repostOption, tab]);
  
    const onClear = (): void => {
      setDateString([
        new Date().toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
      setSource({
        smi: true,
        vk: true,
        tw: true,
        fb: true,
        ig: true,
        tg: true,
        yt: true,
        dz: true,
        ok: true,
      });
      setValue("today");
      setSourceOptions(["tg", "vk", "ok", "dz", "fb", "tw", "yt", "ig", "smi"]);
      setTonality(null);
      setFriendly("");
      setSorting(null);
      setRepostOption("whatever");
      setSwitchValue(false);
      dispatch(feedFilterClear());
      dispatch(changePostPage(1));
    };
  
    const onChangeRepost = (checked: boolean) => {
      setRepostOption(checked ? "containrepost" : "whatever");
      setSwitchValue(checked);
    };
  
    const onChange = ({ target: { value } }: RadioChangeEvent) => {
      setValue(value);
  
      if (value == "today")
        setDateString([
          new Date().toJSON().split("T")[0],
          new Date().toJSON().split("T")[0],
        ]);
      if (value == "week") {
        const start = new Date();
        start.setDate(start.getDate() - 6);
        setDateString([
          start.toJSON().split("T")[0],
          new Date().toJSON().split("T")[0],
        ]);
      }
      if (value == "month") {
        const start = new Date();
        start.setDate(start.getDate() - 29);
        setDateString([
          start.toJSON().split("T")[0],
          new Date().toJSON().split("T")[0],
        ]);
      }
    };
  
    const onPeriodChange = (value: any, dateString: string[]): void => {
      setDateString(dateString);
      dispatch(changePostPage(1));
    };
  
    const handleChangeSort = (value: string) => {
      setSorting(value);
      dispatch(changePostPage(1));
    };
  
    const handleChangeTonal = (value: string) => {
      setTonality(value);
      dispatch(changePostPage(1));
    };
  
    const handleChangeSource = (value: string[]) => {
      for (let key in source) {
        value.indexOf(key) != -1
          ? setSourceChange((prevState) => ({
              ...prevState,
              [key]: true,
            }))
          : setSourceChange((prevState) => ({
              ...prevState,
              [key]: false,
            }));
      }
      setSourceOptions(value);
      //dispatch(changePostPage(1));
    };
  
    const changeSources = () => {
      setSource(sourceChange);
      dispatch(changePostPage(1));
    };
  
    const onCheck: any = (target: any, post: any) => {
      let checkedPostsArr: any = [...checkedPosts];
      if (target == true) checkedPostsArr.push(post);
      else if (target == false) {
        const filteredNumbers = checkedPostsArr.filter(
          (it: any) => it.id !== post.id
        );
        checkedPostsArr = filteredNumbers;
      }
      setCheckedPosts(checkedPostsArr);
    };
  
    const selectAll = () => {
      let checkedPostsArr: any = [];
      postList?.forEach((post) => checkedPostsArr.push(post));
      setCheckedPosts(checkedPostsArr);
    };
  
    const deleteAll = () => {
      if (tab == "post")
        checkedPosts?.forEach((post: any) => {
          dispatch(
            removeRefPost(post.id, post.ownerId, post.network.id, references[0])
          );
          setCheckedPosts([]);
        });
      if (tab == "stop")
        checkedPosts?.forEach((post: any) => {
          dispatch(
            backRemovedPost(post.id, post.ownerId, post.network.id, references[0])
          );
          setCheckedPosts([]);
          //dispatch(removeThreadPost(post.id, post.ownerId, post.network.id))
        });
      if (thread && tab == "post") dispatch(fetchPosts());
      if (thread && tab == "stop")
        setTimeout(() => dispatch(fetchStopPost()), 1000);
    };
  
    const items: TabsProps["items"] = [
      {
        key: "post",
        label: "Посты",
        //children: 'Content of Tab Pane 1',
      },
      {
        key: "stop",
        label: "Исключенные",
        //children: 'Content of Tab Pane 2',
      },
    ];
  
    const onChangeTab = (key: string) => {
      setTab(key);
      dispatch(changePostPage(1));
    };
  
    const changeTonal = (value: any) => {
      console.log(value);
      setTonal(value);
      //if (thread && tab == "post") dispatch(fetchPosts());
      //if (thread && tab == "stop") dispatch(fetchStopPost());
    };
    
  return (
    <div >
      {!isLoading && (
        <Tabs
          className="tabs-group"
          defaultActiveKey={tab}
          items={items}
          onChange={onChangeTab}
        />
      )}
      <div className="white-block">
        {tab == "post" && (
          <>
            <FeedStatistics referencesFilter={referencesFilter} />
            <div className="flex-space">
              <div className="flex">
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#4FD1C5",
                      },
                    },
                  }}
                >
                  <Select
                    style={{ width: 195 }}
                    allowClear={false}
                    onChange={handleChangeSort}
                    disabled={isLoading}
                    options={[
                      { value: "dateAsc", label: "Сначала старые" },
                      { value: "dateDesc", label: "Сначала новые" },
                      { value: "viewDesc", label: "Больше просмотров" },
                      { value: "viewAsc", label: "Меньше просмотров" },
                      { value: "comDesc", label: "Больше комментариев" },
                      { value: "comAsc", label: "Меньше комментариев" },
                      { value: "repostDesc", label: "Больше репостов" },
                      { value: "repostAsc", label: "Меньше репостов" },
                      { value: "likeDesc", label: "Больше лайков" },
                      { value: "likeAsc", label: "Меньше лайков" },
                    ]}
                    placeholder="Сортировать по"
                  />
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#4FD1C5",
                      },
                    },
                  }}
                >
                  <Select
                    value={sourceOptions}
                    mode="multiple"
                    allowClear={true}
                    style={{ width: 200 }}
                    maxTagCount={"responsive"}
                    disabled={isLoading}
                    options={netOptions}
                    placeholder="Тип источника"
                    dropdownRender={(menu) => (
                      <>
                        {menu}

                        <Button type="text" onClick={changeSources}>
                          Применить
                        </Button>
                      </>
                    )}
                    onChange={handleChangeSource}
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        color={"#4FD1C5"}
                        overlayStyle={{ pointerEvents: "none" }}
                        title={omittedValues
                          .map(({ label }) => label)
                          .join(", ")}
                      >
                        <span>Выбранные источники</span>
                      </Tooltip>
                    )}
                  />
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#4FD1C5",
                      },
                    },
                  }}
                >
                  <Select
                    style={{ width: 195 }}
                    allowClear={false}
                    onChange={handleChangeTonal}
                    disabled={isLoading}
                    options={[
                      { value: null, label: "Все" },
                      { value: 1, label: "Позитивные" },
                      { value: -1, label: "Негативные" },
                      { value: 0, label: "Нейтральные" },
                      { value: "unset", label: "Не задана" },
                    ]}
                    placeholder="Тональность"
                  />
                </ConfigProvider>
                <div className="left-border">
                  <p className={isLoading ? "grey" : ""}>Наличие репоста</p>
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: "#D8CCFB",
                        colorPrimaryHover: "#D8CCFB",
                        colorTextTertiary: "rgba(0, 0, 0, 0.2)",
                        colorTextQuaternary: "rgba(0, 0, 0, 0.1)",
                        fontSize: 10,
                      },
                      components: {
                        Switch: {
                          handleSize: 22,
                          trackPadding: -2,
                        },
                      },
                    }}
                  >
                    <Switch
                      value={switchValue}
                      onChange={onChangeRepost}
                      disabled={isLoading}
                    />
                  </ConfigProvider>
                </div>
              </div>

              <div className="flex">
                <ConfigProvider
                  theme={{
                    components: {
                      Radio: {
                        buttonSolidCheckedColor: "#4FD1C5",
                        buttonSolidCheckedBg: "rgba(0, 0, 0, 0.1)",
                        colorPrimary: "rgba(0, 0, 0, 0.1)",
                        buttonSolidCheckedHoverBg: "rgba(0, 0, 0, 0.2)",
                      },
                    },
                  }}
                >
                  <Radio.Group
                    options={options}
                    onChange={onChange}
                    value={value}
                    optionType="button"
                    buttonStyle="solid"
                    disabled={isLoading}
                  />
                </ConfigProvider>

                {value == "period" && (
                  <RangePicker
                    format={"DD-MM-YYYY"}
                    onChange={onPeriodChange}
                    style={{ width: "278px" }}
                    className="choose-period"
                    allowClear={false}
                    locale={locale}
                  />
                )}
              </div>
            </div>
          </>
        )}

        <div className="feed-posts">
          {isLoading && (
            <div className="feed-posts-loader">
              <LoadingOutlined />
            </div>
          )}
          {!isLoading && postCount > 0 && (
            <>
              <div className="flex">
                <div className="grey">
                  Всего постов: {(+postCount).toLocaleString()}
                </div>
                {tab == "post" && (
                  <p onClick={onClear} className="flex clear">
                    Очистить фильтры <CloseOutlined className="info" />
                  </p>
                )}
              </div>
              <div className="post-list">
                {postList?.map((item: { id: React.Key | null | undefined; }, id: React.Key | null | undefined) => (
                  <div className="flex" key={id}>
                    <ConfigProvider
                      theme={{
                        token: {
                          colorPrimary: "#4FD1C5",
                          colorPrimaryHover: "rgba(0, 0, 0, 0.1)",
                          controlInteractiveSize: 25,
                        },
                      }}
                    >
                      <Checkbox
                        checked={
                          checkedPosts.findIndex(
                            (it: any) => it.id == item.id
                          ) != -1
                        }
                        onChange={(e) => onCheck(e.target.checked, item)}
                      ></Checkbox>
                    </ConfigProvider>
                    <Post key={item.id} post={item} changeTonal={changeTonal} />
                  </div>
                ))}
              </div>
              {postCount > 0 ? (
                <div className="feed-posts-pagination">
                  <Pagination
                    size="small"
                    onChange={(value) => {
                      dispatch(changePostPage(value));
                      if (thread && tab == "post") dispatch(fetchPosts());
                      if (thread && tab == "stop")
                        setTimeout(() => dispatch(fetchStopPost()), 1000);
                    }}
                    total={postCount}
                    pageSize={pageSize}
                    current={pageNumber}
                    hideOnSinglePage={true}
                    showSizeChanger={false}
                  />
                </div>
              ) : null}
            </>
          )}
          {!isLoading && postCount == 0 && (
            <div className="flex">
              <div className="feed-posts__empty">Постов пока нет</div>
              <p onClick={onClear}>
                Очистить фильтры <CloseOutlined className="info" />
              </p>
            </div>
          )}
        </div>
      </div>
      {checkedPosts.length > 0 && (
        <div className="fixed-block flex-space">
          <div className="flex">
            <a onClick={selectAll} className="flex btn-cursor">
              <IconChecked />
              Выбрать все
            </a>
            <a onClick={() => setCheckedPosts([])} className="flex btn-cursor">
              <IconUndo />
              Сбросить
            </a>
          </div>
          <div className="flex">
            <div className="grey">Постов выбрано: {checkedPosts.length}</div>
            <div className="red-bg red btn-cursor" onClick={deleteAll}>
              <DeleteOutlined />{" "}
              {tab == "post" ? "Исключить" : "Вернуть в ленту"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostsThread;
